export const ROUTES = {
  HOME: '',
  LOGIN: 'login',
  REGISTER: 'register',
  RESET_PASSWORD: 'reset-password/:token',
  RESOURCE_HUB: 'resource-hub',
  OUR_STORY: 'our-story',
  TILES_FOR_SMILES: 'tiles-for-smiles',
  PRICE_LIST: 'price-list',
  GATHER_COMMITMENT: 'gather-commitment',
  THE_GATHER_COMMITMENT: 'the-gather-commitment',
  ACCOUNT_SETTINGS: 'account-settings',
  QUOTE_DETAIL: 'quote-details',
  CONTACT: 'contact',
  SAMPLE_REQUEST: 'sample-request',
  FAQ: 'faq',
  FAQ_SLUG: ':slug',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  PRIVACY_POLICY: 'privacy-policy',
  STORE_LOCATOR: 'store-locator',
  SEARCH: 'search',
  PAGE_NOT_FOUND: '404',
  NOT_FOUND: '**',
  CHECKOUT: 'checkout',
  PAYMENT: 'payment',
  CHECKOUT_ORDER_ID: ':id',
  CHECKOUT_PAYMENT_TYPE: ':payment_type',
  GUEST_CHECKOUT: 'guest-checkout',
  EXPORT_ID: ':export_id',
  QUOTE_INVOICE: 'quote-invoice',
  TRACK_ID: ':track_id',
  TRACK_ORDER: 'track-order',
  PAYMENT_RESPONSE: 'payment-response',
  GUEST: 'guest',
  STATUS: ':status',
  CARRIER: 'carrier',
  QUOTE_EXAMPLE: 'quote/example',
  PRODUCT: {
    PRODUCT_TYPE: ':product-type',
    COLLECTION_NAME: ':collection-name',
    CATEGORY_NAME: ':category-name',
    FAMILY_FINISH_NAME: ':family-finish-name',
    PRODUCT_SKU_CODE: ':product-sku-code'
  },
  PRODUCT_PARAM_MAPPING: {
    PRODUCT_TYPE: 'product-type',
    COLLECTION_NAME: 'collection-name',
    CATEGORY_NAME: 'category-name',
    FAMILY_FINISH_NAME: 'family-finish-name',
    PRODUCT_SKU_CODE: 'product-sku-code'
  },
  FLOORING: {
    ROOT: 'flooring',
    PRODUCT_TYPE: ':product-type',
    COLLECTION_NAME: ':collection-name',
    CATEGORY_NAME: ':category-name',
  },
  WALLING: {
    ROOT: 'walling',
    PRODUCT_TYPE: ':product-type',
    PRODUCT_NAME: ':product-name',
    CATEGORY_NAME: ':category-name',
  },
  OUTLET: {
    ROOT: 'outlet',
    PRODUCT_TYPE: ':product-type',
  },
  ACCOUNT: {
    QUOTE_ORDER_ID: ':id',
    ROOT: 'account',
    DASHBOARD: 'dashboard',
    QUOTES: 'quotes',
    ORDERS: 'orders',
    SAMPLES: 'samples',
    FAVOURITE: 'favourite',
    GATHER_COMMITMENT: 'gather-commitment',
    THE_GATHER_COMMITMENT: 'the-gather-commitment',
    ACCOUNT_SETTINGS: 'account-settings',
    ORDER_ID: ':id',
  },
  FEATURE_PROJECTS: {
    ROOT: 'projects',
    SLUG: ':slug',
  },
  BLOGS: {
    ROOT: 'blogs',
    SLUG: ':slug',
  },
};
